import React, { useEffect } from 'react';
import {
  Col, message, useAppDispatch, useAppSelector, useNavigate, useTranslation, BasicButtonBG,
  roleService,
} from '@lib/index';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionRequiredAuthError, InteractionStatus } from '@azure/msal-browser';
import {
  assignLoginType,
  assignRole,
  clearState,
  getRolePermissions,
} from '@features/account/AccountSlice';

const AzureLoginControls = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { currentUser } = useAppSelector((state) => state.account);
  const { kitchen } = currentUser;
  const { t } = useTranslation();
  const isAzureAuthenticated = useIsAuthenticated();
  const { useLoginRoleWithAzureTokenMutation } = roleService;
  const [loginRoleWithAzureToken] = useLoginRoleWithAzureTokenMutation();
  const { instance, inProgress, accounts } = useMsal();
  const loginRequest = {
    scopes: ['User.Read'],
  };

  const loginWithAzure = async () => {
    await dispatch(assignLoginType('azure'));
    if (!isAzureAuthenticated && inProgress === InteractionStatus.None) {
      await instance.loginPopup(loginRequest);
      window.location.reload();
    }
  };

  useEffect(() => {
    const handleAzureTokenGeneration = async () => {
      try {
        const response = await loginRoleWithAzureToken({ token: accounts[0].idToken as string })
          .unwrap();
        await dispatch(assignRole(response));
        dispatch(assignLoginType('entra'));
        await dispatch(getRolePermissions(response.token as string));
      } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
          return instance.acquireTokenPopup(loginRequest);
        }
        return message.warning(t('login.loginError'), 5);
      }
      return dispatch(clearState());
    };

    if (isAzureAuthenticated && accounts.length > 0) {
      (async () => {
        await handleAzureTokenGeneration();
      })();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAzureAuthenticated, accounts.length, accounts[0]?.idToken]);

  useEffect(() => {
    if (isAzureAuthenticated && kitchen) {
      navigate('/dashboard');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAzureAuthenticated, kitchen]);

  return (
    <Col xs={24}>
      <BasicButtonBG
        size="large"
        className="mt-4"
        data-cy="login-form-azure"
        onClick={loginWithAzure}
        buttonColorType="default"
        text={t('login.enter')}
        loading={false}
        type="primary"
      />
    </Col>
  );
};

export default AzureLoginControls;
